import {ITypeRadar} from "../../../types";
import {
  IinitiativeAllInfo,
  IPeople,
  IPrevPeople,
  IStakeholder,
  ICRGCIResponse,
} from "../../../pages/StateInitiative/StateInitiative.type";
import {SidebarContentStateInitiativeBasic} from "./SidebarContentStateInitiativeBasicNew";
import {SidebarContentStateInitiativeWorker} from "./SidebarContentStateInitiativeWorker";
import {IWorkerData} from "./sidebarContent.type";
import {useEffect, useState} from "react";
import useFetchDataCrgciWorker from "../../../hooks/useFetchDataCrgciWorker";
import useFetchDataStateInitiativeById from "../../../hooks/useFetchDataStateInitiativeById";
import {Spinner} from "react-bootstrap";

interface IProps {
  isLogin?: boolean;
  role?: string | null;
  data?: IinitiativeAllInfo;
  documentId?: string; // Новый пропс для получения данных по documentId
  typeRadar?: ITypeRadar;
  colorTitle?: string;
  isOpenSideBarStackHolders?: boolean;
  setIsOpenSideBarStackHolders?: (value: boolean) => void;
  activeWorker?: IPeople;
  setActiveWorker?: (value: IPeople) => void;
  idWorkerShowConnections?: string;
  setIdWorkerShowConnections?: (id: string) => void;
  prevIdWorker?: IPrevPeople[];
  setPrevIdWorker?: (PrevPeople: IPrevPeople[]) => void;
  crgciData?: ICRGCIResponse | null;
}

const SideBarContentStateInitiative: React.FC<IProps> = ({
  isLogin,
  role,
  data,
  documentId,
  typeRadar,
  colorTitle,
  isOpenSideBarStackHolders,
  setIsOpenSideBarStackHolders,
  activeWorker,
  setActiveWorker,
  idWorkerShowConnections,
  setIdWorkerShowConnections,
  prevIdWorker,
  setPrevIdWorker,
  crgciData,
}) => {
  const {initiativeData, loading, error} = useFetchDataStateInitiativeById(
    documentId || null
  );

  const actualData = documentId ? initiativeData : data;

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          color: "#fafafa",
          opacity: 0.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          color: "#ff6b6b",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <div>
          <h3>Ошибка загрузки данных</h3>
          <p>{error.message}</p>
        </div>
      </div>
    );
  }

  if (!actualData) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          color: "#fafafa",
          opacity: 0.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <>
      {!isOpenSideBarStackHolders ? (
        <SidebarContentStateInitiativeBasic
          isLogin={isLogin}
          role={role}
          data={documentId ? undefined : data}
          initiativeData={
            documentId && initiativeData
              ? {
                  data: [initiativeData],
                  meta: {
                    pagination: {page: 1, pageSize: 1, pageCount: 1, total: 1},
                  },
                }
              : undefined
          }
          typeRadar={typeRadar}
          colorTitle={colorTitle}
          setIsOpenSideBarStackHolders={setIsOpenSideBarStackHolders}
          setActiveWorker={setActiveWorker}
          setIdWorkerShowConnections={setIdWorkerShowConnections}
          crgciData={crgciData}
        />
      ) : activeWorker && activeWorker.connections ? (
        <SidebarContentStateInitiativeWorker
          worker={activeWorker}
          setIdWorkerShowConnections={setIdWorkerShowConnections}
          setPrevIdWorker={setPrevIdWorker}
          prevIdWorker={prevIdWorker}
        />
      ) : (
        <div style={{color: "#fafafa", padding: "20px"}}>
          {activeWorker
            ? "Связи сотрудника не найдены"
            : "Данные сотрудника не найдены"}
        </div>
      )}
    </>
  );
};
export default SideBarContentStateInitiative;
